import React, { useContext } from 'react';
import { Image } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import PreviewSectionImage from '../../../media/preview-section.png';

export const IdpMarketingImage: React.FC = () => {
  const i18n = useContext(I18nContext);
  return (
    <Image
      src={PreviewSectionImage}
      width={554}
      height={608}
      alt={i18n.getString(_TL_('Microsoft Advertising preview showing ad placements across search results, app store, news and content, and email interface.'))}
    />
  );
};
